import { useState } from "react";

import Button from "../../components/Button";
import Upload, { type UploadFile } from "../../components/Upload";
import SelectedFilesPreview from "../data-management/SelectedFilesPreview";
import BulkUploadService from "../../services/bulk-upload.service";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { toast, type ToastOptions } from "react-toastify";

function useUsersBulkUpload() {
    const [userFile, setUserFile] = useState<UploadFile[]>([]);

    function removeUserFile(fileName: string) {
        const maybeFile = userFile.find(f => f.file.name === fileName);
        if (maybeFile === undefined) {
            return;
        }

        URL.revokeObjectURL(maybeFile.previewUrl);
        setUserFile(files => files.filter(f => f.file.name !== fileName));
    }

    const notificationSettings: ToastOptions = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    };

    function uploadUsers() {
        let uploadFile = userFile[0];
        if (uploadFile === undefined) {
            return;
        }

        BulkUploadService.users({ file: uploadFile.file })
            .then(() => {
                toast.success(`Successfuly uploaded ${uploadFile.file.name}`, notificationSettings);
                removeUserFile(uploadFile.file.name);
            })
            .catch((error) => {
                const maybeMessage = error?.response?.data?.apierror?.message;
                if (maybeMessage !== undefined) {
                    toast.error(maybeMessage, notificationSettings);
                } else {
                    toast.error(`The system was unable to process your file.`, notificationSettings);
                }
            });
    }

    function usersTemplate() {
        BulkUploadService.usersTemplate()
            .then((response) => {
                const url = response.data.s3url;
                const link = document.createElement('a');
                const filename = response.data.filename;

                link.href = url;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((error) => console.log(error));
    }

    return { userFile, setUserFile, removeUserFile, uploadUsers, usersTemplate };
}

function UsersBulkUpload() {
    const { userFile, setUserFile, removeUserFile, uploadUsers, usersTemplate } = useUsersBulkUpload();

    return (<div className="bulk-upload">
        <Button action="secondary" label="Download Users Bulk Template" onClick={usersTemplate}>
            <FontAwesomeIcon icon={faDownload} className="button__icon" />
        </Button>
        {userFile.length > 0 ? (
            <Button action="primary" label="Confirm and upload" onClick={uploadUsers} />
        ) : (
            <Upload
                name="uploadUsers"
                label="Users Bulk Upload"
                setFiles={setUserFile}
                files={userFile}
                disabled={false}
                camera={false}
                documents={[]}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            />
        )}
        <SelectedFilesPreview uploadFiles={userFile} removeFileWithName={removeUserFile} />
    </div>)
}

export default UsersBulkUpload;
